export const formatAddress = (text, size = 5) => {
  if (text) {
    return text.substr(0, size) + "..." + text?.substr(size - size * 2, size);
  } else {
    return "";
  }
};
